import React from 'react';
import { InputField, VerticalField } from '../../../../components/Form';
import { z } from 'zod';
import { DataModelerConfigLabelWithInfo } from '../DataModelerShared';
import { dataModelLabelInfoTooltipOptions } from '../../../../components/KubitTooltip/globalTooltips';

interface IProps {
  isEditMode: boolean;
  sample: number;
  setSample: (sample: number | null) => void;
  cohort: number;
  setCohort: (cohort: number | null) => void;
}

const validPercent = z.coerce.number().nonnegative().lte(100).int();

const strToPercent = (s: string) => {
  let newPerc: number | null = validPercent.safeParse(s).data ?? 100;
  if (newPerc < 1) {
    return 1;
  }
  return newPerc;
};

const SchemaSamplingRate = ({
  isEditMode,
  sample,
  setSample,
  cohort,
  setCohort,
}: IProps) => {
  const setSampleStr = (newStr: string) => {
    setSample(strToPercent(newStr));
  };

  const setCohortStr = (newCohortStr: string) => {
    setCohort(strToPercent(newCohortStr));
  };

  return (
    <>
      <VerticalField noMargin={true}>
        <DataModelerConfigLabelWithInfo
          labelText={'Default Sampling Rate (%)'}
          tooltipOption={dataModelLabelInfoTooltipOptions.defaultSamplingRate}
        />
        <InputField
          type="number"
          min={1}
          max={100}
          value={sample ?? ''}
          onChange={setSampleStr}
          disabled={!isEditMode}
          placeholder={'100'}
        />
      </VerticalField>
      <VerticalField noMargin={true}>
        <DataModelerConfigLabelWithInfo
          labelText={'Default Cohort Sampling Rate (%)'}
          tooltipOption={dataModelLabelInfoTooltipOptions.cohortSamplingRate}
        />
        <InputField
          type="number"
          value={cohort ?? ''}
          onChange={setCohortStr}
          disabled={!isEditMode}
          placeholder={'100'}
        />
      </VerticalField>
    </>
  );
};

export default SchemaSamplingRate;
